import React from 'react';
import PropTypes from 'prop-types';
import { Info } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BatteryLevel from '../../../../../../shared/molecules/BatteryLevel';
import PositionCollectionMode from '../../../../../../shared/molecules/PositionCollectionMode';
import CustomTooltip from '../../../../../../shared/atoms/CustomTooltip';
import AddressIconButton from '../../../../../../shared/molecules/AddressIconButton';

const CorGPSDisplay = ({ sensor }) => {
  const { t } = useTranslation();
  return (
    <>
      {sensor.data.address && (
        <AddressIconButton address={sensor.data.address} />
      )}

      {sensor.data.lsrc && (
        <CustomTooltip
          title={t('machines.facilities.center_pane.sensor.collection_mode', {
            mode: sensor.data.lsrc,
          })}
        >
          <PositionCollectionMode mode={sensor.data.lsrc} hideName />
        </CustomTooltip>
      )}

      {sensor.data.estBattPct && (
        <CustomTooltip
          title={t('machines.facilities.center_pane.sensor.battery_status', {
            percentage: Math.floor(sensor.data.estBattPct),
          })}
        >
          <BatteryLevel percentage={sensor.data.estBattPct} />
        </CustomTooltip>
      )}

      {(sensor.data.hacc || sensor.data.pdop) && (
        <CustomTooltip
          title={
            <Stack>
              {sensor.data.hacc && (
                <Typography>
                  {t(
                    'machines.facilities.center_pane.sensor.horizontal_accuracy',
                    {
                      hacc: sensor.data.hacc,
                    },
                  )}
                </Typography>
              )}
              {sensor.data.pdop && (
                <Typography>
                  {t('machines.facilities.center_pane.sensor.pdop', {
                    pdop: sensor.data.pdop,
                  })}
                </Typography>
              )}
            </Stack>
          }
        >
          <Info />
        </CustomTooltip>
      )}
    </>
  );
};

CorGPSDisplay.propTypes = {
  sensor: PropTypes.shape({
    data: PropTypes.shape({
      lsrc: PropTypes.string,
      address: PropTypes.string,
      hacc: PropTypes.number,
      pdop: PropTypes.number,
      estBattPct: PropTypes.number,
    }),
  }),
};

export default CorGPSDisplay;
